import { render, staticRenderFns } from "./ImportStockModal.vue?vue&type=template&id=13da4329&scoped=true"
import script from "./ImportStockModal.vue?vue&type=script&lang=js"
export * from "./ImportStockModal.vue?vue&type=script&lang=js"
import style0 from "./ImportStockModal.vue?vue&type=style&index=0&id=13da4329&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13da4329",
  null
  
)

export default component.exports